import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeatureListComponent } from './components/feature-list/feature-list.component';
import { FeatureEditorComponent } from './components/feature-editor/feature-editor.component';
import { FeatureManagementContainerComponent } from './components/feature-management-container/feature-management-container.component';

const routes: Routes = [
  {
    path: '',
    component: FeatureManagementContainerComponent,
    children: [
      {
        path: '',
        redirectTo: 'features',
        pathMatch: 'full',
      },
      {
        path: 'features',
        component: FeatureListComponent,
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'features/:id',
        component: FeatureEditorComponent,
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeatureManagementRoutingModule {}
